import { CSSProperties, ReactNode } from 'react'
import { useBanner } from '@/libs/hooks/useBanner'
import { cn } from '@dashboard/ui'

interface SidebarProps {
  children: ReactNode
  open: boolean
  width?: string
  position?: 'left' | 'right'
  style?: CSSProperties
  needOverlay?: boolean
}

export const DrawerSidebar = ({
  children,
  open,
  width,
  position = 'left',
  style,
  needOverlay = true,
}: SidebarProps) => {
  const { getStickyTop, getStickyHeight } = useBanner()
  return (
    <>
      {needOverlay && (
        <div
          className={cn(
            'pointer-events-none fixed inset-0 z-[39] bg-fg-disabled opacity-0 transition duration-300 ease-in-out',
            open && 'opacity-50',
          )}
        />
      )}
      <div
        className={cn(
          'fixed z-40 w-[300px] overflow-auto bg-fg-primary transition duration-300 ease-in-out',
          position === 'left' &&
            cn('left-0 shadow-[24px_0_48px_-25px_rgba(16,24,40,0.18)]', open ? 'translate-x-0' : '-translate-x-full'),
          position === 'right' &&
            cn('right-0 shadow-[-24px_0_48px_-25px_rgba(16,24,40,0.18)]', open ? 'translate-x-0' : 'translate-x-full'),
          getStickyTop(),
          getStickyHeight(),
        )}
        style={{ ...style, width: width }}
      >
        {children}
      </div>
    </>
  )
}
